import React from 'react'
import { FastField, Field } from 'formik'
import { Place } from '../../types/utils'
import { Customer } from '../../types/customer'
import placeService from '../../services/placeService'
import { graphQLClient } from '../../services/authService'

import FormikMultipleCheckbox from '../FormikMultipleCheckbox'
import FormikAsyncSelect from '../FormikAsyncSelect'
import customerQueries from '../../services/graphql/customers/queries'
import FormikInput from '../FormikInput'
import { OfferType } from '../../utils/config'
import { useUser } from '../../hooks/useUser'

type OffersFiltersFormProps = {
  isSubmitting: boolean
}

const TYPE = [OfferType.reward, OfferType.offer].map((item) => ({ value: item.toLocaleUpperCase(), label: item }))

const OffersFiltersForm: React.FC<OffersFiltersFormProps> = () => {
  const user = useUser()

  const placeOptions = async (inputValue: string) => {
    if (inputValue === '') return []
    return await placeService.getAll({ where: { name_contains: inputValue } })
  }

  const customerOptions = async (inputValue: string) => {
    if (inputValue === '') return []
    const response = await graphQLClient.request(customerQueries.getAll, {
      where: { name_contains: inputValue },
    })
    return response.customers
  }

  return (
    <div className="mb-6 space-y-6 px-4 sm:px-6">
      <fieldset>
        <p className="my-4 font-medium text-gray-700">Type</p>
        <FastField name="type" component={FormikMultipleCheckbox} items={TYPE} />
      </fieldset>
      <Field
        name="locations"
        component={FormikAsyncSelect}
        label="Location"
        isMulti
        loadOptions={placeOptions}
        getOptionLabel={(item: Place) => item.name}
        getOptionValue={(item: Place) => item.id}
        placeholder="Type Location Name"
      />
      {user.data?.type === 'BUZZL' ? (
        <Field
          name="customers"
          component={FormikAsyncSelect}
          label="Customer"
          isMulti
          loadOptions={customerOptions}
          getOptionLabel={(item: Customer) => item.name}
          getOptionValue={(item: Customer) => item.id}
          placeholder="Select Customer"
        />
      ) : null}
      <FastField name="nbClaimed" label="Number of Claims" component={FormikInput} type="number" />
      <FastField name="cost" label="Cost" component={FormikInput} type="number" />
    </div>
  )
}

export default OffersFiltersForm
